import PropTypes from 'prop-types';

import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';

import MaterialDivider from './MaterialDivider';

const EncapsulantPhaseForm = ({ index, data }) => {
  const { 
    handleDelete, handleInputChange, initialValues, formErrors
  } = useContext(MaterialsCaptureContext);

  return(
    <Box mt={4}>
      <MaterialDivider 
        index={index} 
        title={'Encapsulant phase'} 
        showDeleteIcon={data?.is_new_encapsulant_phase} 
        handleDelete={handleDelete} 
        deleteIndex={data?.index} 
      />

      <Grid container spacing={1} mt={1}>
        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Sample Name"
            name={`lnp_sample_name-${data?.index}`}
            value={data?.lnp_sample_name}
            onChange={e => 
              handleInputChange(e, data?.index, 'lnp_sample_name', e.target.value)
            }
            helperText={formErrors[`lnp_sample_name-${data?.index}`]}
            error={`lnp_sample_name-${data?.index}` in formErrors}
            disabled={!data?.is_new_encapsulant_phase}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <Autocomplete
            value={data?.operator}
            onChange={(e, newValue) => 
              handleInputChange(e, data?.index, 'operator', newValue)
            }
            onInputChange={(e, newValue) =>
              handleInputChange(e, data?.index, 'operator', newValue)
            }
            options={initialValues?.operator}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Operator" 
                placeholder="Type to search Operator..." 
                error={`operator-${data?.index}` in formErrors}
                helperText={formErrors[`operator-${data?.index}`]}
              />
            )}
            freeSolo
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Solvent"
            name={`solvent-${data?.index}`}
            value={data?.solvent}
            onChange={e => 
              handleInputChange(e, data?.index, 'solvent', e.target.value)
            }
            helperText={formErrors[`solvent-${data?.index}`]}
            error={`solvent-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <FormControl fullWidth>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label='Date prepared'
                name={`date_prepared-${data?.index}`}
                value={data?.date_prepared} 
                onChange={e => 
                  handleInputChange(e, data?.index, 'date_prepared', e)
                } 
                maxDate={initialValues?.today}
                renderInput={(params) => 
                  <TextField 
                    {...params} 
                    error={Boolean(formErrors[`date_prepared-${data?.index}`])}
                    helperText={formErrors[`date_prepared-${data?.index}`]}
                  />
                }
              />
            </LocalizationProvider>
          </FormControl>
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Ionisable"
            name={`ionisable_name-${data?.index}`}
            value={data?.ionisable_name}
            onChange={e => 
              handleInputChange(e, data?.index, 'ionisable_name', e.target.value)
            }
            helperText={formErrors[`ionisable_name-${data?.index}`]}
            error={`ionisable_name-${data?.index}` in formErrors}
            disabled={!data?.is_new_encapsulant_phase}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Sterol"
            name={`sterol_name-${data?.index}`}
            value={data?.sterol_name}
            onChange={e => 
              handleInputChange(e, data?.index, 'sterol_name', e.target.value)
            }
            helperText={formErrors[`sterol_name-${data?.index}`]}
            error={`sterol_name-${data?.index}` in formErrors}
            disabled={!data?.is_new_encapsulant_phase}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="PEG"
            name={`peg_name-${data?.index}`}
            value={data?.peg_name}
            onChange={e => 
              handleInputChange(e, data?.index, 'peg_name', e.target.value)
            }
            helperText={formErrors[`peg_name-${data?.index}`]}
            error={`peg_name-${data?.index}` in formErrors}
            disabled={!data?.is_new_encapsulant_phase}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Neutral"
            name={`neutral_name-${data?.index}`}
            value={data?.neutral_name}
            onChange={e => 
              handleInputChange(e, data?.index, 'neutral_name', e.target.value)
            }
            helperText={formErrors[`neutral_name-${data?.index}`]}
            error={`neutral_name-${data?.index}` in formErrors}
            disabled={!data?.is_new_encapsulant_phase}
            fullWidth
          />
        </Grid>
      </Grid>
    </Box>
  );
};

EncapsulantPhaseForm.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default EncapsulantPhaseForm;